// @mui
import {
  TableRow,
  TableCell,
  Typography,
  Grid,
  Card,
  Table,
  TableBody,
  TableContainer,
  Paper,
  Button,
  Stack,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

// Localization
import useLocales from 'src/hooks/useLocales';
import Label from 'src/components/Label';

// Store & MobX
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores/store';

// API
import { baseUrl } from 'src/api/baseUrl';
import { DateConverter } from 'src/sections/common/DateConverter';
import Iconify from 'src/components/Iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { useNavigate } from 'react-router';
import { IFinancialPayment } from 'src/@types/Choqorak/MainTables/FinancialPayment/FinancialPayment';

// Types


type Props = {
  row?: IFinancialPayment;
};

export default observer(function FinancialPaymentDetailTableRow({ row }: Props) {
  const { translate } = useLocales();
  const { FinancialPaymentStore } = useStore();
  const { selectedFinancialPaymentDetail } = FinancialPaymentStore;
  const Url = baseUrl;
  const navigate = useNavigate();
  return (
    <>
      {/* Main Details */}
      {/* <Grid item xs={6} md={6}>
       
      </Grid> */}
      <Grid item xs={12} md={12} sx={{ padding: '50px' }}>
        <Stack direction="row" spacing={1.5} sx={{ mt: 1, ml: 0, mb: 2 }}>
          <Button
            variant="contained"
            color="error"
            size="small"
            startIcon={<Iconify icon="eva:arrow-ios-back-fill" />}
            onClick={() => {
              navigate(PATH_DASHBOARD.FinancialPayment.list);
              // clearCustomer();
            }}
          >
            {translate('CRUD.BackToList')}
          </Button>
        </Stack>
        <Card sx={{ p: 2 }}>
          <Typography
            variant="h5"
            sx={{ fontSize: 14, textAlign: 'center', mb: 2, color: 'warning.main' }}
            color="text.secondary"
            gutterBottom
          >
            <Label
              variant="ghost"
              sx={{ textTransform: 'capitalize', fontSize: 15, p: 2 }}
              color="warning"
            >
              {translate('FinancialPayment.Title')} {translate('CRUD.Detail')}
            </Label>
          </Typography>

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: '100%' }} size="small">
              <TableBody>
                <TableRow>

                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('Report.Dollor')}
                  </TableCell>
                  <TableCell>{selectedFinancialPaymentDetail?.dollor}</TableCell>

                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('Report.Afghani')}
                  </TableCell>
                  <TableCell>{selectedFinancialPaymentDetail?.afghani}</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('FinancialPayment.Date')}
                  </TableCell>
                  <TableCell>{<DateConverter date={selectedFinancialPaymentDetail?.paymentDate} />}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('RentPaymentPrint.SerialNumber')}
                  </TableCell>
                  <TableCell>{selectedFinancialPaymentDetail?.serialNumber}</TableCell>

                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('FinancialPayment.Description')}
                  </TableCell>
                  <TableCell>{selectedFinancialPaymentDetail?.description}</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', color: 'info.main', fontSize: '16px' }}>
                    {translate('contractsInfo.Attachments')}
                  </TableCell>
                  <TableCell>
                    <a
                      href={Url + selectedFinancialPaymentDetail?.attachmentFiles}
                      style={{ color: 'orange' }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <DownloadIcon />
                    </a>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
      </Grid>

      {/* Attachments */}

     

    </>
  );
});
